import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

import { createDropShadow } from "./drop-shadow.ts";

export const createInnerShadow = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  effect: FigmaRestApi.InnerShadowEffect,
) =>
  createDropShadow(
    stylesFormatsConfig,
    effect as unknown as FigmaRestApi.DropShadowEffect,
  ) + " inset";
